var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { ErrorUnsupportedCharset } from '../error';
import { BYTES_INTERVAL } from './common';
export var BOM_UTF8 = [0xef, 0xbb, 0xbf];
export var BOM_UTF16_BE = [0xfe, 0xff];
export var BOM_UTF16_LE = BOM_UTF16_BE.slice().reverse();
// These are not part of the specification
export var BOM_UTF32_BE = [0x00, 0x00, 0xfe, 0xff];
export var BOM_UTF32_LE = BOM_UTF32_BE.slice().reverse();
export var DECODE_UTF8 = 'utf-8';
export var DECODE_UTF16_BE = 'utf-16be';
export var DECODE_UTF16_LE = 'utf-16le';
export var decodeUtf = function (buffer, progressCallback) {
    var output = decodeUtfBOM(buffer, progressCallback).output;
    return output;
};
export var decodeUtf8 = function (buffer, progressCallback) {
    if (progressCallback) {
        progressCallback(0);
    }
    var outputView = '';
    var byteBuffer = new Uint8Array(buffer);
    var nIdx = 0;
    for (var nPart = void 0, nLen = byteBuffer.length; nIdx < nLen; nIdx++) {
        nPart = byteBuffer[nIdx];
        outputView += String.fromCharCode(nPart > 251 && nPart < 254 && nIdx + 5 < nLen /* six bytes */
            /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
            ? (nPart - 252) * 1073741824 + (byteBuffer[++nIdx] - 128 << 24) + (byteBuffer[++nIdx] - 128 << 18) + (byteBuffer[++nIdx] - 128 << 12) + (byteBuffer[++nIdx] - 128 << 6) + byteBuffer[++nIdx] - 128
            : nPart > 247 && nPart < 252 && nIdx + 4 < nLen /* five bytes */
                ? (nPart - 248 << 24) + (byteBuffer[++nIdx] - 128 << 18) + (byteBuffer[++nIdx] - 128 << 12) + (byteBuffer[++nIdx] - 128 << 6) + byteBuffer[++nIdx] - 128
                : nPart > 239 && nPart < 248 && nIdx + 3 < nLen /* four bytes */
                    ? (nPart - 240 << 18) + (byteBuffer[++nIdx] - 128 << 12) + (byteBuffer[++nIdx] - 128 << 6) + byteBuffer[++nIdx] - 128
                    : nPart > 223 && nPart < 240 && nIdx + 2 < nLen /* three bytes */
                        ? (nPart - 224 << 12) + (byteBuffer[++nIdx] - 128 << 6) + byteBuffer[++nIdx] - 128
                        : nPart > 191 && nPart < 224 && nIdx + 1 < nLen /* two bytes */
                            ? (nPart - 192 << 6) + byteBuffer[++nIdx] - 128
                            : /* nPart < 127 ? */ /* one byte */ nPart);
        if (progressCallback && nIdx % BYTES_INTERVAL === 0) {
            progressCallback(nIdx);
        }
    }
    if (progressCallback) {
        progressCallback(nIdx);
    }
    return outputView;
};
var decodeUtf16 = function (buffer, isBe, progressCallback) {
    if (progressCallback) {
        progressCallback(0);
    }
    var outputView = '';
    var byteBuffer = new Uint8Array(buffer);
    for (var i = 0; i < byteBuffer.length; i += 2) {
        var a = byteBuffer[i], b = byteBuffer[i + 1];
        var code = isBe ? a * 16 + b : b * 16 + a;
        outputView += String.fromCharCode(code);
        if (progressCallback && ((i + 1) / 2) % BYTES_INTERVAL === 0) {
            progressCallback(i);
        }
    }
    return outputView;
};
export var decodeUtf16be = function (buffer, progressCallback) { return decodeUtf16(buffer, true, progressCallback); };
export var decodeUtf16le = function (buffer, progressCallback) { return decodeUtf16(buffer, false, progressCallback); };
export var decodeUtfBOM = function (buffer, progressCallback) {
    if (progressCallback) {
        progressCallback(0);
    }
    var byteBuffer = new Uint8Array(buffer);
    var startsWith = function (bom) {
        if (byteBuffer.length < bom.length) {
            return false;
        }
        for (var i = 0; i < bom.length; i++) {
            if (byteBuffer[i] !== bom[i]) {
                return false;
            }
        }
        return true;
    };
    var boms = [[DECODE_UTF8, BOM_UTF8], [DECODE_UTF16_BE, BOM_UTF16_BE], [DECODE_UTF16_LE, BOM_UTF16_LE]];
    var optional = boms.map(function (_a) {
        var _b = __read(_a, 2), charset = _b[0], bom = _b[1];
        return ({ charset: charset, bom: bom });
    }).find(function (_a) {
        var bom = _a.bom;
        return startsWith(bom);
    });
    if ([BOM_UTF32_BE, BOM_UTF32_LE].some(function (bom) { return startsWith(bom); })) {
        throw new ErrorUnsupportedCharset("Unsupported charset detected from BOM: 'utf-32'", 'utf-32');
    }
    var bomCharset = optional !== undefined ? optional.charset : null;
    var byteBufferWithoutBOM = optional !== undefined ? byteBuffer.slice(optional.bom.length) : byteBuffer;
    var charset = bomCharset !== null ? bomCharset : DECODE_UTF8; // No BOM = defaults to UTF-8
    var output;
    if (charset === DECODE_UTF8) {
        output = decodeUtf8(byteBufferWithoutBOM);
    }
    else if (charset === DECODE_UTF16_BE) {
        output = decodeUtf16be(byteBufferWithoutBOM);
    }
    else if (charset === DECODE_UTF16_LE) {
        output = decodeUtf16le(byteBufferWithoutBOM);
    }
    else {
        throw new Error();
    }
    if (progressCallback) {
        progressCallback(byteBuffer.length);
    }
    return { output: output, bomCharset: bomCharset };
};
//# sourceMappingURL=utf.js.map